export const clamp = (n, low, high) => Math.max(low, Math.min(high, n));
export const overlap = (a, b) => a.x < b.x + b.w && a.x + a.w > b.x && a.y < b.y + b.h && a.y + a.h > b.y;
export function read(key, fallback) {
  try { return JSON.parse(localStorage.getItem(key)) ?? fallback; } catch { return fallback; }
}
export function save(key, value) {
  try { localStorage.setItem(key, JSON.stringify(value)); } catch { /* Private browsing can disable storage. */ }
}
export function randomFrom(seed) {
  let n = 2166136261;
  for (const c of String(seed)) n = Math.imul(n ^ c.charCodeAt(0), 16777619);
  return () => { n += 0x6D2B79F5; let t = n; t = Math.imul(t ^ t >>> 15, t | 1); t ^= t + Math.imul(t ^ t >>> 7, t | 61); return ((t ^ t >>> 14) >>> 0) / 4294967296; };
}
let muted = read('ed-muted', false) === true;
let audio;
export const isMuted = () => muted;
export function stopAudio() {
  document.querySelectorAll('audio').forEach(a => { a.pause(); a.currentTime = 0; });
}
export function setMuted(value) {
  muted = value;
  save('ed-muted', value);
  document.querySelectorAll('audio').forEach(a => { a.muted = value; });
  if (value) { stopAudio(); if (audio) audio.suspend().catch(() => {}); }
  else unlockAudio();
  document.dispatchEvent(new CustomEvent('ed-sound-change'));
}
export function unlockAudio() {
  if (muted) return;
  try { audio ||= new (window.AudioContext || window.webkitAudioContext)(); if (audio.state === 'suspended') audio.resume().catch(() => {}); } catch { /* Sound is optional. */ }
}
export function tone(kind = 'shot') {
  if (muted || !audio || audio.state !== 'running') return;
  const notes = { shot: [640, 220, .045], hit: [180, 45, .12], collect: [420, 1000, .15], clear: [800, 1600, .09], hurt: [160, 60, .24], wave: [330, 880, .35] };
  const [start, end, duration] = notes[kind] || notes.shot;
  const osc = audio.createOscillator(), gain = audio.createGain(), now = audio.currentTime;
  osc.type = kind === 'hurt' ? 'sawtooth' : 'square';
  osc.frequency.setValueAtTime(start, now); osc.frequency.exponentialRampToValueAtTime(end, now + duration);
  gain.gain.setValueAtTime(.035, now); gain.gain.exponentialRampToValueAtTime(.001, now + duration);
  osc.connect(gain); gain.connect(audio.destination); osc.start(); osc.stop(now + duration);
}
export function discover(id) { document.dispatchEvent(new CustomEvent('ed-discover', { detail: id })); }
export async function copyText(text) {
  try { await navigator.clipboard.writeText(text); return true; }
  catch {
    const field = document.createElement('textarea'); field.value = text; field.className = 'copy-fallback';
    (document.querySelector('dialog[open]') || document.body).append(field); field.select();
    let ok = false; try { ok = document.execCommand('copy'); } catch { /* Show failure to caller. */ }
    field.remove(); return ok;
  }
}
export function label(ctx, text, x, y, size = 18, color = '#e8f1ff', align = 'left') {
  ctx.font = `bold ${size}px "Courier Prime", monospace`; ctx.fillStyle = color; ctx.textAlign = align; ctx.fillText(text, x, y);
}
